// eslint-disable-next-line import/prefer-default-export
export enum EFeaturesStatus {
  Working = 'working',
  Partly = 'partly',
  Untested = 'untested',
  NotWorking = 'notWorking',
}
